import { createAsyncThunk } from '@reduxjs/toolkit';
import payrollServiceApiInstance from '../../../../../config/payrollApiConfig';
import { LogQueryParams } from './employeeSalaryStructureTypes';

// Create Employee Salary Structure
export const createEmployeeSalaryStructure = createAsyncThunk(
  'employeeSalaryStructure/create',
  async (data: any, { rejectWithValue }) => {
    try {
      const response = await payrollServiceApiInstance.post('/employeesalarystructure', data);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || 'Failed to create Employee Salary Structure');
    }
  }
);

// Fetch All Employee Salary Structures
export const fetchEmployeeSalaryStructures = createAsyncThunk(
  'employeeSalaryStructure/fetchAll',
  async (_, { rejectWithValue }) => {
    try {
      const response = await payrollServiceApiInstance.get('/employeesalarystructure');
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || 'Failed to fetch Employee Salary Structures');
    }
  }
);

// Fetch Employee Salary Structure by ID
export const fetchEmployeeSalaryStructureById = createAsyncThunk(
  'employeeSalaryStructure/fetchById',
  async (structureId: number, { rejectWithValue }) => {
    try {
      const response = await payrollServiceApiInstance.get(`/employeesalarystructure/${structureId}`);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || 'Failed to fetch Employee Salary Structure');
    }
  }
);

// Update Employee Salary Structure
export const updateEmployeeSalaryStructure = createAsyncThunk(
  'employeeSalaryStructure/update',
  async ({ id, ...data }: any & { id: number }, { rejectWithValue }) => {
    try {
      const response = await payrollServiceApiInstance.put(`/employeesalarystructure/${id}`, data);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || 'Failed to update Employee Salary Structure');
    }
  }
);

// Delete Employee Salary Structure
export const deleteEmployeeSalaryStructure = createAsyncThunk(
  'employeeSalaryStructure/delete',
  async (structureId: number, { rejectWithValue }) => {
    try {
      const response = await payrollServiceApiInstance.delete(`/employeesalarystructure/${structureId}`);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || 'Failed to delete Employee Salary Structure');
    }
  }
);

// Fetch All Employee Leave Data
export const fetchAllEmployeeLeaveData = createAsyncThunk(
  'employeeLeave/fetchAll',
  async ({ month, year }: { month: number; year: number }, { rejectWithValue }) => {
    try {
      const response = await payrollServiceApiInstance.get(`/employee-salary-calculation`, {
        params: { month, year },
      });
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || 'Failed to fetch Employee Leave Data');
    }
  }
);


// Fetch Employee Salary Structures by Employee ID
export const fetchSalaryStructureByEmployeeId = createAsyncThunk(
  'employeeSalaryStructure/fetchByEmployeeId',
  async (employeeId: number, { rejectWithValue }) => {
    try {
      const response = await payrollServiceApiInstance.get(`/salary-structure/employee/${employeeId}`);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || 'Failed to fetch Salary Structure by Employee ID');
    }
  }
);

export const fetchAllSalaryStructureLogs = createAsyncThunk(
  'employeeSalaryStructure/fetchAllLogs',
  async (params: LogQueryParams | undefined, { rejectWithValue }) => {
    try {
      const response = await payrollServiceApiInstance.get('/employee/salarystructure/logs', {
        params, // will be undefined if not provided (OK)
      });
      return response.data; // expect { data: [...] }
    } catch (error: any) {
      return rejectWithValue(error.response?.data || 'Failed to fetch Salary Structure Logs');
    }
  }
);

// Fetch logs by employeeId (same query params supported)
export const fetchSalaryStructureLogsByEmployeeId = createAsyncThunk(
  'employeeSalaryStructure/fetchLogsByEmployeeId',
  async (
    { employeeId, ...params }: { employeeId: number } & LogQueryParams,
    { rejectWithValue }
  ) => {
    try {
      const response = await payrollServiceApiInstance.get(
        `/employeesalarystructure/logs/employee/${employeeId}`,
        { params }
      );
      return response.data; // expect { data: [...] }
    } catch (error: any) {
      return rejectWithValue(error.response?.data || 'Failed to fetch Salary Structure Logs by Employee ID');
    }
  }
);
